module.exports = __webpack_public_path__ + "static/media/mapsk.4a9cb79c.png";